import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=ea1d002a&scoped=true&"
import script from "./privilege.vue?vue&type=script&lang=js&"
export * from "./privilege.vue?vue&type=script&lang=js&"
import style0 from "./privilege.vue?vue&type=style&index=0&id=ea1d002a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1d002a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea1d002a')) {
      api.createRecord('ea1d002a', component.options)
    } else {
      api.reload('ea1d002a', component.options)
    }
    module.hot.accept("./privilege.vue?vue&type=template&id=ea1d002a&scoped=true&", function () {
      api.rerender('ea1d002a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vip/privilege.vue"
export default component.exports